// frontend/src/hooks/useMembers.js

import { useEffect } from 'react';

export function useMembers({
  session,
  origin,
  page,
  limit,
  appliedFilters,
  createdByHash,
  setMembers,
  setTotal,
  setPage,
  setLimit,
  setLoading
}) {
  useEffect(() => {
    if (!session?.hash) return;

    setLoading(true);

    const jwtToken = sessionStorage.getItem('jwt_token');
    const isInvitationHash = session.hash.startsWith('inv_');
    const leaderActingAsGuest =
      session?.role === 'guest' && !!session?.parentHash;
    const cameFromInvitations = origin === 'invitations';

    const endpoint = `${process.env.REACT_APP_API_BASE}/api/member`;
    const inHashFlow =
      isInvitationHash || leaderActingAsGuest || cameFromInvitations;

    const headers = {
      'Content-Type': 'application/json',
      'x-access-hash': session.hash,
      ...(jwtToken && !inHashFlow
        ? { Authorization: `Bearer ${jwtToken}` }
        : {}),
    };

    const qs = new URLSearchParams({
      page: String(page),
      limit: String(limit)
    });

    if (appliedFilters.nationality)
      qs.set('nationality', appliedFilters.nationality.trim());
    if (appliedFilters.national_id)
      qs.set('national_id', appliedFilters.national_id.trim());
    if (appliedFilters.passport)
      qs.set('passport', appliedFilters.passport.trim());
    if (appliedFilters.first_name)
      qs.set('first_name', appliedFilters.first_name.trim());
    if (appliedFilters.last_name)
      qs.set('last_name', appliedFilters.last_name.trim());

    // Scope: filtrar por creador (solo aplica para leader)
    if (createdByHash && session?.role === 'leader') {
      qs.set('created_by_hash', createdByHash);
    }

    fetch(`${endpoint}?${qs.toString()}`, { headers })
      .then(res => {
        if (!res.ok) throw new Error(`Members failed: ${res.status}`);
        return res.json();
      })
      .then(json => {
        setMembers(Array.isArray(json.data) ? json.data : []);
        setTotal(Number(json.meta?.total || 0));
        setPage(Number(json.meta?.page || 1));
        setLimit(Number(json.meta?.limit || limit));
        setLoading(false);
      })
      .catch(() => setLoading(false));

  }, [session, origin, page, limit, appliedFilters, createdByHash]);
}